import { useEffect } from 'react';
import { LocalStorage } from './utils/storage/local-storage';

const DynamicManifest = () => {
  useEffect(() => {
    const appDetails = LocalStorage.getItem('domian_details');
    if (!appDetails) return;
    const parsed = JSON.parse(appDetails);
    const origin = window.location.origin;  // e.g., "https://app.brand2social.com"
    const startPath = '/login';  // Or dynamically set based on your app logic (e.g., logged in? -> '/dashboard')
    const manifest = {
      name: parsed.org_name || 'Brand2Social',
      short_name: 'B2S',
      display: 'standalone',
      start_url: `${origin}${startPath}`,  // Full URL: "https://app.brand2social.com/register"
      theme_color: '#000000',
      background_color: '#ffffff',
      icons: [
        {
          src: parsed.small_icon ||  "https://app.brand2social.com/static/media/logo.0ee6a9e1026c6efd867b.png",
          sizes: '192x192',
          type: 'image/png',
        },
        {
          src: parsed.large_icon || parsed.small_icon || "https://app.brand2social.com/static/media/logo.0ee6a9e1026c6efd867b.png",
          sizes: '512x512',
          type: 'image/png',
        },
      ],
    };
    const stringManifest = JSON.stringify(manifest);
    const blob = new Blob([stringManifest], { type: 'application/json' });
    const manifestURL = URL.createObjectURL(blob);

    // Update link
    let link = document.getElementById('manifest-placeholder');
    if (!link) {
      link = document.createElement('link');
      link.id = 'manifest-placeholder';
      link.rel = 'manifest';
      document.head.appendChild(link);
    }
    link.href = manifestURL;

    // Update theme-color meta
    let themeMeta = document.querySelector('meta[name="theme-color"]');
    if (!themeMeta) {
      themeMeta = document.createElement('meta');
      themeMeta.name = 'theme-color';
      document.head.appendChild(themeMeta);
    }
    themeMeta.content = manifest.theme_color;

    // Important: Clean up old blob URLs
    return () => {
      URL.revokeObjectURL(manifestURL);
    };
  }, []);

  return null;
};

export default DynamicManifest;
